<div class="vi-wrapper" 
      [style.width.px]="calcVideoWidth(videoWidth)" 
      [style.marginLeft]="videoWidth > 0 ? 'auto' : null" 
      [style.marginRight]="videoWidth > 0 ? 'auto' : null"
      >
  <!-- Dashed border box -->
  <div class="vi-box">

    <!-- Eye caret sits ON the top dashed border -->
    <div class="vi-eye-caret">
      <ion-icon name="eye-outline"></ion-icon>
    </div>

    <!-- Header row: TTS + title -->
    <div class="vi-header">
      <div class="vi-tts-wrap">
        <app-messagebubble [text]="ttsText"></app-messagebubble>
      </div>
      <span class="vi-title">Video Settings</span>
    </div>

    <!-- Instruction lines -->
    <div class="vi-instructions">

      <div class="vi-row vi-row--plain">
        <span class="vi-text">Tap the arrow (&lt;) for video options</span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon vi-arrows">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polyline points="5,0.5 0.5,0.5 0.5,5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="0.5" y1="0.5" x2="6" y2="6" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <polyline points="15,0.5 19.5,0.5 19.5,5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="19.5" y1="0.5" x2="14" y2="6" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <polyline points="5,19.5 0.5,19.5 0.5,15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="0.5" y1="19.5" x2="6" y2="14" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            <polyline points="15,19.5 19.5,19.5 19.5,15" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <line x1="19.5" y1="19.5" x2="14" y2="14" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="vi-text">Watch in full screen <span class="vi-mobile-note">(mobile app only)</span></span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon">
          <ion-icon name="settings-outline" style="font-size: 16px; color: #000;"></ion-icon>
        </span>
        <span class="vi-text">Change speed or language</span>
      </div>

      <div class="vi-row">
        <span class="vi-bullet-icon vi-cc">
          <span class="vi-cc-badge">cc</span>
        </span>
        <span class="vi-text">Turn on subtitles</span>
      </div>

    </div>
  </div>
</div>
